import React from "react";
import servicesData from "../../assets/data/servicesData.json"; // Ensure the path is correct

function ServiceArea({ className }) {
  // Helper function to dynamically require images to avoid import errors
  const getImage = (imagePath) => {
    try {
      return require(`../../assets/img/${imagePath}`);
    } catch (err) {
      console.error(`Could not load image: ${imagePath}`);
      return undefined; // or a default image path
    }
  };

  return (
    <section className={className || ""}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="section-title text-center mb-50 tg-heading-subheading animation-style3">
              <span className="sub-title tg-element-title">Co zajišťujeme</span>
              <h2 className="title tg-element-title">
                Jaké služby pro Vás dokážeme zajistit?
              </h2>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          {servicesData.map((service) => (
            <div key={service.id} className="col-lg-4 col-md-6 col-sm-10">
              <div
                className="services-item"
                data-wow-delay={service.delay}
                style={{
                  backgroundImage: `url(${getImage(service.image)})`,
                }}
              >
                <div className="services-overlay-content">
                  <h2 className="title">
                    <a href={`/services/${service.links}`}>{service.title}</a>
                  </h2>
                  <p>{service.description}</p>
                  <a href={`/services/${service.links}`} className="read-more">
                    Zjistit více <i className="fas fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServiceArea;
